import script from "./NavigationRenderer.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationRenderer.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationRenderer.vue?vue&type=style&index=0&id=902d1492&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-902d1492"]])

export default __exports__